import React, { PureComponent } from 'react'
import { View } from 'react-native'
import theme from '../../../../styles/theme'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  background: ${theme.colours.white}
`

const ColumnWrapper = styled(View)`
  flex-direction: row;
  justify-content: center;
  padding: ${theme.gutterUnit}px;
`

const Column = styled(View)`
  flex-direction: column;
  width: ${props => 100 / props.count}%;
  justify-content: flex-end;
  max-width: ${props => `${props.count <= 4 ? '25%' : '100%'}`};
`

const BoxWrapper = styled(View)`
  padding: 2px ${theme.gutterUnit}px;
`

const RoundedBox = styled(View)`
  background: ${props => props.background};
  padding:  ${({ collapse }) => collapse ? '2px' : `${theme.gutterUnit}px`};
  width: 100%;
  align-items: center;
  border-radius: ${theme.gutterUnit / 2}px;
  flex-direction: ${props => props.collapse ? 'row' : 'column'};
  justify-content: center;
`

const scores = [
  { label: '0', criteria: v => v === 0, colour: '#12a86c' },
  { label: '1', criteria: v => v === 1, colour: '#36bdac' },
  { label: '2', criteria: v => v === 2, colour: '#19d1a4' },
  { label: '3-4', criteria: v => v > 2 && v < 5, colour: '#e46c60' },
  { label: '5+', criteria: v => v > 4, colour: '#bf1c33' }
]

const stackThreshold = 5

export default class CapitalRatio extends PureComponent {
  render () {
    const columns = scores.map(s => {
      const teams = this.props.data.filter(team => s.criteria(team.value))
      return {
        ...s,
        teams: teams.map(t => ({
          ...t,
          collapse: teams.length > stackThreshold
        }))
      }
    }).filter(score => score.teams.length > 0)

    return (
      <Container>
        <ColumnWrapper>
          {columns.map((column, i) => (
            <Column count={columns.length} key={i}>
              {column.teams.map((team, i) => (
                <BoxWrapper key={i}>
                  <RoundedBox background={team.team === this.props.currentTeam ? theme.colours.chart.orange : column.colour} collapse={team.collapse}>
                    <Text white size={team.collapse ? 'm' : 's'} overrides={{ paddingBottom: team.collapse ? 0 : 1, paddingRight: team.collapse ? 5 : 0 }}>{team.name}</Text>
                    <Text white size={team.collapse ? 'm' : 'l'} bold={team.collapse}>{team.value}</Text>
                  </RoundedBox>
                </BoxWrapper>
              ))}
            </Column>
          ))}
        </ColumnWrapper>
        <ColumnWrapper style={{ borderTopColor: theme.colours.bordergrey, borderTopWidth: 1 }}>
          {columns.map((column, i) => (
            <Column count={columns.length} key={i}>
              <BoxWrapper>
                <RoundedBox background={column.colour}>
                  <Text white size='l'>{column.label}</Text>
                </RoundedBox>
              </BoxWrapper>
            </Column>
          ))}
        </ColumnWrapper>
      </Container>
    )
  }
}
